import styled from "styled-components";

export const Container = styled.div`
  padding: 10px;
  img {
    max-width: 100%;
  }
`;
